import React, { useState } from 'react';
import { Modal, Box, Typography, Tabs, Tab } from '@mui/material';
import ImageUpload from '../UserAuthentication/ImageUpload';
import ChangePassword from '../UserAuthentication/ChangePassword';
import { uploadImage } from '../../utils/api';
const EditProfile = ({ open, onClose, onPasswordSubmit, userId }) => {
    const [isSubView, setIsSubView] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const handleImageUpload = async (file) => {
        const formData = new FormData();
        formData.append('image', file); // Append the file
        formData.append('userId', userId); // Include userId in the form data

        try {
            const response = await uploadImage(formData); // Call the API
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };


    return (
        <Modal open={open} onClose={onClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <Box
                sx={{
                    width: 500,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    position: 'relative', // For stacking subview
                }}
            >
                {/* Dimmed background when subview is active */}
                <Box
                    sx={{
                        opacity: isSubView ? 0.5 : 1, // Reduce opacity for background content
                        pointerEvents: isSubView ? 'none' : 'auto', // Disable interactions with background when subview is active
                    }}
                >
                    <Typography fontFamily="GveretLevin" direction="rtl" textAlign="right" variant="h6" mb={2}>
                        ערוך פרופיל
                    </Typography>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        centered
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#C4A484',
                            },
                            '& .MuiTab-root.Mui-selected': {
                                color: '#C4A484',
                            },
                        }}
                    >
                        <Tab label="ערוך תמונה" />
                        <Tab label="שנה סיסמה" />
                    </Tabs>
                    <Box sx={{ mt: 2 }}>
                        {activeTab === 0 && (
                            <Typography textAlign="right" direction="rtl" >
                                לחיצה על ערוך חשבון לשינוי תמונה
                            </Typography >
                        )}
                        {activeTab === 1 && (
                            <Typography textAlign="right" direction="rtl" >
                                לחיצה על שינוי סיסמה על מנת לשנות אותה
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <button
                            onClick={() => setIsSubView(true)}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: "#C4A484", // Red button
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                        >
                            {activeTab === 0 ? "ערוך תמונה" : "שנה סיסמה"}
                        </button>
                    </Box>
                </Box>

                {/* SubView overlay */}
                {isSubView && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 2, // Match parent border-radius
                            zIndex: 10, // Ensure it overlays above parent
                        }}
                    >
                        {activeTab === 0 && (
                            <ImageUpload
                                open={true}
                                onClose={() => setIsSubView(false)} // Go back to main view
                                onUpload={(file) => {
                                    handleImageUpload(file); // Upload the file and update the parent
                                    setIsSubView(false); // Close the subview
                                }}
                            />

                        )}


                        {activeTab === 1 && (
                            <ChangePassword
                                open={true}
                                onClose={() => setIsSubView(false)} // Go back to main view
                                onSubmit={(formData) => {
                                    onPasswordSubmit(formData);
                                    setIsSubView(false); // Return to main view after successful submission
                                }}
                            />
                        )}
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default EditProfile;
